import axios from "axios";
import React, { useState } from "react";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { utils, writeFile } from "xlsx";
import { useGlobalContext } from "../../../../Contexts/GlobalContext";
import { BASE_URL, CustomTablePagination } from "../../../../Utlils";
import NoData from "../../../../components/NoData";
import TableLoader from "./TableLoader";
import { getStatsDetail } from "./helperData";
import { useQuery } from "@tanstack/react-query";

const TerminationData = ({ data }) => {
  const { id } = useParams();
  const { setSnackbar } = useGlobalContext();
  const [filters, setFilters] = useState({
    startDate: new Date(
      new Date().getFullYear(),
      new Date().getMonth() - 3,
      new Date().getDate()
    )?.toLocaleDateString("en-CA"),

    endDate: new Date().toLocaleDateString("en-CA"),
  });
  const [tempFilters, setTempFilters] = useState(filters);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const {
    data: terminatedSessionsData,
    isLoading: terminatedSessionsDataLoading,
    isError: terminatedSessionsDataError,
  } = useQuery({
    queryFn: () => getTerminatedSessions(),
    queryKey: [
      `${id}-terminatedSessions-${filters?.startDate}-${filters?.endDate}-${page}-${rowsPerPage}`,
    ],
    staleTime: 10000,
    cacheTime: 15000,
  });
  //DOWNLOAD TO EXCEL:
  const DownloadToExcel = () => {
    var elt = document.getElementById("table-to-xls-DATA");
    var wb = utils.table_to_book(elt, { sheet: "MiratsQuanto" });
    const worksheet = wb.Sheets[wb.SheetNames[0]];
    const jsonData = utils.sheet_to_json(worksheet);
    const fieldsToRemove = ["RID", "Supplier Account", "SRC ID"];
    const filteredData = jsonData.map((row) => {
      fieldsToRemove.forEach((field) => delete row[field]);
      return row;
    });
    const newWorksheet = utils.json_to_sheet(filteredData);
    const newWorkbook = utils.book_new();
    utils.book_append_sheet(newWorkbook, newWorksheet, "MiratsQuanto");
    writeFile(
      newWorkbook,
      `Mirats Quanto - SN#${data?.surveyNumber} - Termination Data.xlsx`
    );
    setSnackbar({
      open: true,
      severity: "success",
      msg: "Excel Sheet Downloaded!",
    });
  };

  //GET TERMINATED SESSIONS:
  const getTerminatedSessions = async () => {
    try {
      const sessionData = await axios.get(
        `${BASE_URL}/session/terminated-sessions?surveyID=${id}&startDate=${
          filters.startDate
        }&endDate=${filters.endDate}&page=${
          Number(page) + 1
        }&rows=${rowsPerPage}`
      );

      return sessionData?.data;
    } catch (error) {
      return error;
    }
  };
  const refetchSurveyTerminatedSessionsData = (start, end) => {
    setFilters({ startDate: start, endDate: end });
  };
  // pagination function
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // console.log(data);
  // console.log({
  //   terminatedSessionsData,
  //   terminatedSessionsDataLoading,
  //   terminatedSessionsDataError,
  // });
  return (
    <div className="w-full flex flex-col gap-6">
      {/* Header */}
      <div className="w-full py-4 px-6 bg-white border-b border-[#E0E0E0]">
        <h1 className="text-[#0226BE] text-[24px] font-[500] mb-1">
          Termination Data
        </h1>
        <p className="text-[#666] text-[14px] font-[400]">
          View terminated survey sessions and termination reasons
        </p>
      </div>

      {/* Filters */}
      <div className="w-full bg-white border border-[#E0E0E0] rounded-md p-5">
        <div className="flex items-center justify-between flex-wrap gap-4">
          <div className="flex items-center gap-3 flex-wrap">
            <label className="text-[#666] text-[14px] font-[400]">Field Date</label>
            <input
              type="date"
              className="border border-[#E0E0E0] h-[40px] px-3 rounded-md text-[#333] text-[14px] focus:outline-none focus:ring-2 focus:ring-[#0226BE] focus:border-transparent"
              value={tempFilters?.startDate}
              onChange={(e) => {
                setTempFilters((prev) => ({
                  ...prev,
                  startDate: e.target.value,
                }));
              }}
            />
            <span className="text-[#666] text-[14px]">To</span>
            <input
              type="date"
              className="border border-[#E0E0E0] h-[40px] px-3 rounded-md text-[#333] text-[14px] focus:outline-none focus:ring-2 focus:ring-[#0226BE] focus:border-transparent"
              value={tempFilters?.endDate}
              onChange={(e) => {
                setTempFilters((prev) => ({
                  ...prev,
                  endDate: e.target.value,
                }));
              }}
            />
            <button
              className="border border-[#0226BE] text-[#0226BE] py-2 px-4 text-[14px] font-[500] rounded-md hover:bg-[#0226BE] hover:text-white transition-colors"
              onClick={(e) => setFilters(tempFilters)}
            >
              Search
            </button>
            <button
              className="text-[#666] text-[14px] font-[400] hover:text-[#0226BE] transition-colors"
              onClick={(e) => {
                const start = new Date(
                  new Date().getFullYear(),
                  new Date().getMonth() - 3,
                  new Date().getDate()
                )?.toLocaleDateString("en-CA");
                const end = new Date().toLocaleDateString("en-CA");

                if (
                  tempFilters?.startDate !== start ||
                  tempFilters?.endDate !== end
                ) {
                  setTempFilters({
                    startDate: start,
                    endDate: end,
                  });
                  refetchSurveyTerminatedSessionsData(start, end);
                }
              }}
            >
              Clear filters
            </button>
          </div>
          <button
            className="bg-[#0226BE] text-white py-2 px-4 text-[14px] font-[500] rounded-md hover:bg-[#021ea8] transition-colors"
            onClick={(e) => DownloadToExcel()}
          >
            Export To Excel
          </button>
        </div>
      </div>

      {/* Table */}
      <div className="w-full bg-white border border-[#E0E0E0] rounded-md overflow-hidden">
        <div className="w-full flex flex-col">
          {terminatedSessionsDataLoading ? (
            <TableLoader />
          ) : terminatedSessionsDataError ? (
            <div className="w-full  h-[200px] flex items-center justify-center">
              <h1 className="text-[#666666]">Something went wrong </h1>
            </div>
          ) : (
            <div className="w-full overflow-x-auto containerScroll">
              <table
                className="whitespace-nowrap text-left w-full"
                id="table-to-xls-DATA"
              >
                <thead className="h-[50px] bg-gray-50 border-b border-[#E0E0E0]">
                  <tr>
                    {[
                      "Ref ID",
                      "Survey No.",
                      "Project No.",
                      "Mirats Status",
                      "Client Status",
                      "Date",
                    ]?.map((d, idx) => (
                      <th key={idx} className="text-[#666] text-[13px] font-[500] px-4 text-start">
                        {d}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {terminatedSessionsData?.data?.length ? (
                    terminatedSessionsData?.data?.map((da, idx) => (
                      <tr key={idx} className="border-b border-[#E0E0E0] transition-colors cursor-pointer hover:bg-blue-50/30">
                        <td className="px-4 py-4 text-[#333] font-[400] text-[13px] text-start">
                          {da?.ref_id}
                        </td>
                        <td className="px-4 py-4 text-[#333] font-[400] text-[13px] text-start">
                          {data?.surveyNumber}
                        </td>
                        <td className="px-4 py-4 text-[#333] font-[400] text-[13px] text-start">
                          {data?.projectNumber}
                        </td>
                        <td className="px-4 py-4 text-[#333] font-[400] text-[13px] text-start">
                          {getStatsDetail("mirats", da?.mirats_status)} (
                          {da?.mirats_status})
                        </td>
                        <td className="px-4 py-4 text-[#333] font-[400] text-[13px] text-start">
                          {getStatsDetail("client", da?.client_status)} (
                          {da?.client_status})
                        </td>
                        <td className="px-4 py-4 text-[#333] font-[400] text-[13px] text-start">
                          {new Date(da?.date)?.toLocaleDateString("en-UK", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          })}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <td colSpan={12}>
                      <div className="py-10">
                        <NoData
                          msg={
                            <div className="flex items-center gap-[10px]">
                              <h1>Try Changing the filters</h1>
                              {/* <button
                    className="py-1 px-4 bg-primary text-[#fff] rounded-md font-[500]"
                    onClick={(e) => console.log("hehe")}
                  >
                    Clear
                  </button> */}
                            </div>
                          }
                        />
                      </div>
                    </td>
                  )}
                </tbody>
              </table>
            </div>
          )}
          <CustomTablePagination
            rowsPerPageOptions={[5, 10, 25, 50]}
            sx={{ fontSize: "10px" }}
            count={terminatedSessionsData?.pagination?.totalRecords || 0}
            rowsPerPage={rowsPerPage}
            page={page}
            componentsProps={{
              select: {
                "aria-label": "rows per page",
              },
              actions: {
                showFirstButton: true,
                showLastButton: true,
              },
            }}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
      </div>
    </div>
  );
};

export default TerminationData;
